'use client'

import type { ComponentProps } from 'react'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Badge } from '@cocoonspace/ui/components/badge'
import { Card } from '@cocoonspace/ui/components/card'
import { Separator } from '@cocoonspace/ui/components/separator'
import { useLingui } from '@lingui/react/macro'
import Image from 'next/image'

import type { Post } from '~/domains/blog/list-posts'
import { ContentContainer } from '../content-container'
import { NotionPage } from '../notion-page'

export const DetailsPage = ({
	post,
	recordMap,
}: {
	post: Post
	recordMap: ComponentProps<typeof NotionPage>['recordMap']
}) => {
	const { t } = useLingui()

	return (
		<ContentContainer className='!p-0 [&_.notion-h]:m-0'>
			{!!post.cover?.url && (
				<Card className='relative m-0 h-48 w-full overflow-hidden p-0 sm:h-72 md:h-96 [&_img]:!max-w-full'>
					<Image
						className='m-0 size-full object-cover object-center'
						src={post.cover.url}
						alt={post.cover.name ?? ''}
						fill
						priority
						sizes='100vw'
					/>
				</Card>
			)}

			{/* {!!post.twicPicsSrc && (
				<TwicImg
					ratio='none'
					alt={post.title}
					className='[&_img]:!max-w-full m-0 h-96 shadow-xs'
					src={post.twicPicsSrc}
				/>
			)} */}

			<h1 className='!m-0'>{post.title}</h1>
			<div className='bg-primary h-3 w-24 rounded-full' />

			<NotionPage recordMap={recordMap} />

			<Separator />

			<div className='flex items-center gap-1 text-sm'>
				<span>{t`Publié le :`}</span>

				{dateTimeUtils(post.publishedAt).format('DD/MM/YYYY')}

				{!!post.categories?.length && (
					<div className='ml-auto flex flex-wrap gap-2'>
						{post.categories?.map(({ name }) => (
							<Badge
								className='capitalize'
								key={name}
								size='sm'
							>
								# {name}
							</Badge>
						))}
					</div>
				)}
			</div>
		</ContentContainer>
	)
}
